export default function (props: any) {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="icon">
                <g id="Group 161268616">
                    <path
                        id="Vector 490"
                        d="M5.10178 14.1699C11.5125 17.2887 20.9719 21.8905 22.4708 22.6197C22.6034 22.6842 22.7516 22.6814 22.8845 22.6175L40.3692 14.2069M22.6741 41.5082V22.849M5.04276 13.9194C11.4412 10.6337 20.9286 5.76182 22.4615 4.97463C22.5992 4.90394 22.7558 4.90696 22.8938 4.97702L39.8264 13.5745C40.3808 13.856 40.7301 14.425 40.7301 15.0468V33.0307C40.7301 33.2161 40.6238 33.3851 40.4567 33.4655L22.8845 41.9182C22.7516 41.9821 22.5968 41.9817 22.4642 41.9172L5.09238 33.4661C4.92633 33.3853 4.82095 33.2175 4.82095 33.0328C4.82095 31.1729 4.82095 21.1069 4.82095 14.2827C4.82095 14.128 4.90509 13.9901 5.04276 13.9194Z"
                        stroke="#FFBD3C"
                        strokeWidth="2.47692"
                    />
                    <path id="Vector 491" d="M30.8769 9.20801L13.9888 18.3758V26.5786" stroke="#FFBD3C" strokeWidth="2.47692" strokeLinecap="round" />
                </g>
            </g>
        </svg>
    );
}
